module.exports = __webpack_public_path__ + "img/operator-mono-light.1494d886.png";